// HRx is a product of Upscale BD Ltd. — company details shown on legal pages.
export const COMPANY = {
  name: "Upscale BD Ltd.",
  product: "HRx",
  email: "upscalebdltd@gmail.com",
  phone: "+880 16 1109 0323",
  website: "www.upscalebd.com",
  websiteUrl: "https://upscalebd.com",
  supportHours: "Sunday to Thursday, 10:00 AM – 6:00 PM (BST)",
  address: "House-25, Road-5, Block-J, Banasree, Rampura, Dhaka-1219",
  tradeLicense: "TRAD/DSCC/025220/2022",
};

/** HRx's own contact page — every "contact us / request a demo" goes here. */
export const CONTACT_PATH = "/contact";
